// extracted by mini-css-extract-plugin
var _1 = "#007ac9";
var _2 = "coordinatesProjectionMarker-O5_u";
var _3 = "crossroadMarker-g693";
var _4 = "crossroadMarkerHighlight-NDnH";
var _5 = "#575757";
var _6 = "disabledMarker-KjZM";
var _7 = "1.5rem";
var _8 = "#dedede";
var _9 = "#adf";
var _a = "1rem";
var _b = "#bebebe";
var _c = "municipalityMarker-xexd";
var _d = "municipalityMarkerHighlight-hxc4";
var _e = ".8rem";
var _f = "stopMarker-HDdJ";
var _10 = "stopMarkerHighlight-x8v3";
var _11 = "timeAlignmentMarker-DgFa";
var _12 = "#000";
export { _1 as "busBlue", _2 as "coordinatesProjectionMarker", _3 as "crossroadMarker", _4 as "crossroadMarkerHighlight", _5 as "darkGrey", _6 as "disabledMarker", _7 as "extraLargeFontSize", _8 as "lightGrey", _9 as "lightblue", _a as "mediumFontSize", _b as "mediumLightGrey", _c as "municipalityMarker", _d as "municipalityMarkerHighlight", _e as "smallFontSize", _f as "stopMarker", _10 as "stopMarkerHighlight", _11 as "timeAlignmentMarker", _12 as "unusedNodeColor" }
